import React, { useRef, useEffect, useState } from "react";
import ReactSwitch from "react-switch"; // Import the base React Switch

const AccessControlPanel = ({ 
  isOpen, 
  onClose, 
  partnerId, 
  savePartnerAccess, 
  accessSettings = {}
}) => {
  const [immediateResponseAccess, setImmediateResponseAccess] = useState(accessSettings.immediate_resp || false);
  const [damageAssessmentAccess, setDamageAssessmentAccess] = useState(accessSettings.dmg_assessment || false);
  const [assistanceLogAccess, setAssistanceLogAccess] = useState(accessSettings.assistance_log || false);
  const [lockboxAccess, setLockboxAccess] = useState(accessSettings.lockbox || false);
  
  const panelRef = useRef(null);

  // Update state when accessSettings change
  useEffect(() => {
    setImmediateResponseAccess(accessSettings.immediate_resp || false);
    setDamageAssessmentAccess(accessSettings.dmg_assessment || false);
    setAssistanceLogAccess(accessSettings.assistance_log || false);
    setLockboxAccess(accessSettings.lockbox || false);
  }, [accessSettings]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isOpen &&
        panelRef.current &&
        !panelRef.current.contains(event.target) &&
        !event.target.closest(".relative") // Don't close if clicking on the menu container
      ) {
        onClose();
      }
    };

    // Only add the listener if the panel is open
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  
  return (
    <div 
      ref={panelRef}
      className="absolute right-8 top-0 z-50 w-64 rounded-md bg-white shadow-lg"
    >
      <div className="p-4">
        <div className="flex items-center justify-between mb-4">
          <h2 className="font-bold text-sm">Edit Access</h2>
          <button 
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            ✕
          </button>
        </div>
        
        <div className="mb-3">
          <div className="flex justify-between items-center">
            <div>
              <div className="font-semibold text-sm">Immediate Response</div>
              <div className="text-xs text-gray-500">
                {immediateResponseAccess ? "View Only" : "Read and Write"}
              </div>
            </div>
            <ReactSwitch
              checked={immediateResponseAccess}
              onChange={setImmediateResponseAccess}
              onColor="#0A8525"
              offColor="#8F8F8F"
              checkedIcon={false}
              uncheckedIcon={false}
              height={20}
              width={40}
              handleDiameter={16}
            />
          </div>
        </div>
        
        <div className="mb-3">
          <div className="flex justify-between items-center">
            <div>
              <div className="font-semibold text-sm">Damage Assessment</div>
              <div className="text-xs text-gray-500">
                {damageAssessmentAccess ? "View Only" : "Read and Write"}
              </div>
            </div>
            <ReactSwitch
              checked={damageAssessmentAccess}
              onChange={setDamageAssessmentAccess}
              onColor="#0A8525"
              offColor="#8F8F8F"
              checkedIcon={false}
              uncheckedIcon={false}
              height={20}
              width={40}
              handleDiameter={16}
            />
          </div>
        </div>
        
        <div className="mb-3">
          <div className="flex justify-between items-center">
            <div>
              <div className="font-semibold text-sm">Assistance Log</div>
              <div className="text-xs text-gray-500">
                {assistanceLogAccess ? "View Only" : "Read and Write"}
              </div>
            </div>
            <ReactSwitch
              checked={assistanceLogAccess}
              onChange={setAssistanceLogAccess}
              onColor="#0A8525"
              offColor="#8F8F8F"
              checkedIcon={false}
              uncheckedIcon={false}
              height={20}
              width={40}
              handleDiameter={16}
            />
          </div>
        </div>
        
        <div className="mb-3">
          <div className="flex justify-between items-center">
            <div>
              <div className="font-semibold text-sm">Lockbox</div>
              <div className="text-xs text-gray-500">
                {lockboxAccess ? "View Only" : "Read and Write"}
              </div>
            </div>
            <ReactSwitch
              checked={lockboxAccess}
              onChange={setLockboxAccess}
              onColor="#0A8525"
              offColor="#8F8F8F"
              checkedIcon={false}
              uncheckedIcon={false}
              height={20}
              width={40}
              handleDiameter={16}
            />
          </div>
        </div>
        
        <div className="flex justify-end mt-4">
          <button 
            className="bg-green-500 text-white px-3 py-1 text-xs rounded mr-2"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              
              // Prepare the access settings object
              const accessSettings = {
                immediateResponse: immediateResponseAccess,
                damageAssessment: damageAssessmentAccess,
                assistanceLog: assistanceLogAccess,
                lockbox: lockboxAccess
              };
              
              // Call the save handler from the parent component
              savePartnerAccess(partnerId, accessSettings);
            }}
          >
            Save
          </button>
          <button 
            className="bg-gray-300 text-gray-700 px-3 py-1 text-xs rounded"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onClose();
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default AccessControlPanel;